import { Slot } from 'expo-router';
import React from 'react';
import TabBar from 'shared/components/TabBar/TabBar';
import DesktopNavigation from 'shared/components/vxl/navigation/DesktopNavigation/DesktopNavigation';
import useShouldShowDesktopNavigation from 'shared/hooks/useShouldShowDesktopNavigation';

function TabsLayoutWeb() {
  const shouldShowDesktopNavigation = useShouldShowDesktopNavigation();

  if (shouldShowDesktopNavigation) {
    return (
      <DesktopNavigation>
        <Slot />
      </DesktopNavigation>
    );
  }
  return <TabBar />;
}

export default TabsLayoutWeb;
